import api from "./client";

export function submitRegistration(payload) {
  return api.post("/register", payload).then((res) => res.data);
}

export function getDemoProductionRegistration() {
  return api.get('/demo/production-registration').then((res) => res.data);
}

export function submitDemoProductionRegistration(payload) {
  return api.post('/demo/production-registration', payload).then((res) => res.data);
}

export function getRegistrationConfiguration() {
  return api.get('/registration/configuration').then((res) => res.data);
}

export function getSetupInvite(token) {
  return api.get("/setup-invite", { params: { token } }).then((res) => res.data);
}

export function completeSetupInvite(payload) {
  return api.post("/setup-invite/complete", payload).then((res) => res.data);
}
